
import BlogList from '~/components/blog/BlogList.vue';
import BlogListPreviewItem from '~/components/blog/BlogListPreviewItem.vue';
import BlogPostCitation from '~/components/blog/BlogPostCitation.vue';
import BlogPostHeadline from '~/components/blog/BlogPostHeadline.vue';
import BlogPostImage from '~/components/blog/BlogPostImage.vue';
import BlogPostSectionHeadline from '~/components/blog/BlogPostSectionHeadline.vue';
import BlogPostShare from '~/components/blog/BlogPostShare.vue';
import BlogPostSubtitle from '~/components/blog/BlogPostSubtitle.vue';
import BlogPostTextBlock from '~/components/blog/BlogPostTextBlock.vue';
import IconArrowRight from '~/components/icons/IconArrowRight.vue';
import IconArrowUpRight from '~/components/icons/IconArrowUpRight.vue';
export default {
  components: { IconArrowRight, BlogPostHeadline, BlogPostSectionHeadline, BlogPostImage, BlogPostTextBlock, BlogPostSubtitle, IconArrowUpRight, BlogPostCitation, BlogPostShare, BlogList, BlogListPreviewItem },
  data () {
    return {
      shares: ['Linkedin', 'Facebook', 'Twitter', 'Email', 'Whatsapp']
    };
  },
  mounted () {
    this.$store.commit('closeMenu');

    this.$nextTick(() => {
      const shareOffset = document.getElementById('blog-share').offsetHeight + 200;

      window.addEventListener('scroll', () => {
        const element = document.getElementById('blog-share');
        // const introElement = document.getElementById('blog-intro');
        // const blogHeadline = document.getElementById('blog-headline');
        const blogElement = document.getElementById('blog-content');

        // console.log('windowscroll: ' + document.documentElement.scrollTop + ' - trigger: ' + (blogElement.offsetTop + blogElement.offsetHeight - shareOffset));

        if (document.documentElement.scrollTop >= blogElement.offsetTop) {
          if (document.documentElement.scrollTop >= blogElement.offsetTop + blogElement.offsetHeight - shareOffset) {
            element.style.position = 'absolute';
            element.style.top = 'unset';
            element.style.bottom = '0px';
          } else {
            element.style.position = 'fixed';
            element.style.top = '200px';
          }
        } else {
          element.style.position = 'absolute';
        }
      });
    });
  }
};
